import { render, staticRenderFns } from "./AccessEmail.vue?vue&type=template&id=20846988"
import script from "./AccessEmail.vue?vue&type=script&lang=js"
export * from "./AccessEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports